/**
 * AgendamentosReport - Scheduled counts report table
 */
import React from 'react';
import { RelatorioGeraisTable, type Column } from './RelatorioGeraisTable';

const columns: Column[] = [
  // N218: `format: 'status'` troca o codigo cru ('EXECUTADA') pelo rotulo PT.
  { key: 'status', label: 'Status', width: '120px', format: 'status' },
  { key: 'data_hora', label: 'Data/Hora', width: '140px' },
  { key: 'codigo', label: 'Código', align: 'center', width: '80px' },
  { key: 'hospital_codigo_sap', label: 'Código SAP', align: 'center', width: '100px' },
  { key: 'hospital_nome', label: 'Hospital', width: '200px' },
  { key: 'hospital_cnpj', label: 'CNPJ', width: '160px' },
  { key: 'hospital_cidade', label: 'Cidade', width: '130px' },
  { key: 'hospital_uf', label: 'UF', width: '50px', align: 'center' },
  { key: 'cliente_nome', label: 'Cliente', width: '180px' },
  { key: 'auditores_str', label: 'Auditores', width: '180px' },
  { key: 'motivo_cancelamento', label: 'Motivo', width: '150px' },
  { key: 'observacoes', label: 'Observações', width: '200px' },
  { key: 'total_sistema', label: 'Sistema', format: 'number', width: '90px', align: 'right' },
  { key: 'total_contado', label: 'Contado', format: 'number', width: '90px', align: 'right' },
  { key: 'total_sobra', label: 'Sobra', format: 'number', width: '90px', align: 'right' },
  { key: 'total_falta', label: 'Falta', format: 'number', width: '90px', align: 'right' },
  { key: 'faturar', label: 'Coletado', format: 'number', width: '90px', align: 'right' },
  { key: 'total_segregar', label: 'Segreg.', format: 'number', width: '90px', align: 'right' },
  { key: 'acuracidade', label: 'Acurac. %', format: 'number', width: '90px', align: 'right' },
  { key: 'justificativa_intervalo', label: 'Justificativa', width: '250px' },
];

function statusBadgeClass(status: string): string {
  switch (status) {
    case 'EXECUTADA': return 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300';
    case 'EM_EXECUCAO': return 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300';
    case 'CONFIRMADA': return 'bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300';
    case 'AGENDADA': return 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300';
    case 'CANCELADA':
    case 'NAO_EXECUTADA': return 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300';
    default: return 'bg-gray-100 dark:bg-gray-900/30 text-gray-700 dark:text-gray-300';
  }
}

interface Props {
  data: any[];
  loading?: boolean;
  totalRecords?: number;
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
}

export const AgendamentosReport: React.FC<Props> = ({
  data,
  loading,
  totalRecords,
  currentPage,
  totalPages,
  onPageChange,
}) => {
  return (
    <RelatorioGeraisTable
      columns={columns}
      data={data}
      loading={loading}
      highlightRow={(row) => {
        const cls = statusBadgeClass(row.status);
        return cls ? '' : '';
      }}
      emptyMessage="Nenhum agendamento encontrado no período selecionado."
      totalRecords={totalRecords}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
    />
  );
};
